export const SET_TIME_ZONE_ID = 'SET_TIME_ZONE_ID';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_EVENT_INSIGHTS_DATA = 'SET_EVENT_INSIGHTS_DATA';
export const SET_LOADER_STATUS = 'SET_LOADER_STATUS';